import { Injectable } from '@angular/core';
import { SiteConfigService } from './core.site-config.service';

declare var gtag: Function;

@Injectable()
export class AnalyticsService {

    private initialized = false;

    constructor(private siteConfigService: SiteConfigService) {}

    initialize(): void {
        if (this.initialized) return;
        const measurementId: string = this.siteConfigService.getConfig('gaMeasurementId', '');
        if (!measurementId) return;

        // Set up dataLayer queue before script loads so gtag calls are buffered.
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).gtag = function() { (window as any).dataLayer.push(arguments); };
        gtag('js', new Date());
        gtag('config', measurementId, { send_page_view: false });

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
        document.head.appendChild(script);

        this.initialized = true;
    }

    trackPageView(path: string, title: string): void {
        if (!this.initialized || typeof gtag === 'undefined') return;
        gtag('event', 'page_view', { page_path: path, page_title: title });
    }

}
